import { render, staticRenderFns } from "./PatrolPoints.vue?vue&type=template&id=f1ca1570&scoped=true"
import script from "./PatrolPoints.vue?vue&type=script&lang=js"
export * from "./PatrolPoints.vue?vue&type=script&lang=js"
import style0 from "./PatrolPoints.vue?vue&type=style&index=0&id=f1ca1570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca1570",
  null
  
)

export default component.exports